<template>
  <div class="main">
    <h1>Warehouse dashboard</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
